import { render, staticRenderFns } from "./RecoverProjectGroupDialog.vue?vue&type=template&id=a10e7ab6&"
import script from "./RecoverProjectGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./RecoverProjectGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports